angular.module('dnecom')
    .service('ProductUploadUtils', ["Upload", "$http", "$q", function ProductProcessMetaDetailsController(Upload, $http, $q) {
        this.upload = function (store, file, callback) {
            var deferred = $q.defer();

            if (file) {
                return Upload.upload({
                        url: Routing.generate('upload_file', {store: store.id}),
                        data: {
                            file: file
                        }
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            callback(response.data.media);
                        } else {
                            alert(response.data.message);
                        }
                    }, function () {
                        alert('There was a problem with image uploading.');
                    });
            } else {
                deferred.reject();
            }

            return deferred.promise;
        };

        this.uploadUrl = function (store, url, callback) {
            var defered = $q.defer();

            if (url && url.length > 0) {
                return $http.post(Routing.generate('upload_file', {store: store.id}), {
                        image: url
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            callback(response.data.media);
                        } else {
                            alert(response.data.message);
                        }
                    }, function () {
                        alert('There as a problem with image uploading.');
                    });
            } else {
                defered.reject();

                alert('Please enter image URL.');
            }

            return defered.promise;
        };

        this.setProductFieldValue = function (product, parentField, field, value) {
            if (!product.properties[parentField]) {
                product.properties[parentField] = {};
            }

            product.properties[parentField][field] = value;
        };

        return this;
    }]);
